module.exports = __webpack_public_path__ + "img/how-rpc-work-2.e5e4727e.png";